import {
  isValidEmail,
  isValidNumber,
  isValidRequired,
  isValidPhone,
  isValidURL,
} from "@huub-web/utils";

import type { TranslationKey, ValidationResult } from "../contexts";
import type {
  ValidationRule,
  ValidationRules,
  ValidationValue,
} from "../props";

/**
 * Validates an input value against a set of validation rules.
 *
 * @param value - The input value to validate. Can be of type string, boolean, number, string array, or undefined.
 * @param rules - An array of validation rules to apply. Possible values are "required", "number", "email", and "url".
 * @param name - The name of the field being validated. Defaults to "field". This name will be used in error messages.
 *
 * @returns An object containing a boolean `valid` indicating if the input is valid, and an array of `errors` with validation error messages.
 */
export const validateInput = <T = ValidationValue>(
  value: T,
  rules: ValidationRules,
  name?: string,
): ValidationResult => {
  if (!rules || rules.length === 0) {
    return {
      success: true,
      value,
      errors: [],
    };
  }

  // name = ucfirst(toHumanCase(name, false));

  let success = true;
  const errors: TranslationKey[] = [];

  rules.forEach((rule: ValidationRule) => {
    // console.log("→ (validateInput)", rule, value);

    if (rule === "required") {
      if (!isValidRequired(value) || value === false) {
        success = false;
        errors.push("validation.required");
      }
    } else if (rule === "email" && value) {
      if (!isValidEmail(value)) {
        success = false;
        errors.push("validation.email");
      }
    } else if (rule === "url" && value) {
      if (!isValidURL(value)) {
        success = false;
        errors.push("validation.email");
      }
    } else if (rule === "number" && value) {
      if (!isValidNumber(value)) {
        success = false;
        errors.push("validation.number");
      }
    } else if (rule === "phone" && value) {
      if (!isValidPhone(value)) {
        success = false;
        errors.push("validation.phone");
      }
    } else if (rule && value) {
      console.error(`Validation rule ${rule} not added to validation set.`);
    }

    // TODO: regex
  });

  return {
    success,
    errors,
    value,
    name,
  };
};
